import React from "react";
import { InputBox } from "../../Common";
import styles from "./partnerConfig.module.css";

const DropdownWithLabelValueAlt = ({
    value,
    onChange,
    onBlur,
    disabled = false,
    inputsDisabled = false,
    title = "Dropdown Options",
    placeholder = {
        label: "Enter label",
        value: "Enter value",
        alt: "Enter alt text"
    },
    allowedValues = []
}) => {
    const parseDropdownData = (value) => {
        try {
            if (typeof value === 'string') {
                return JSON.parse(value);
            }
            return Array.isArray(value) ? value : [];
        } catch {
            return [];
        }
    };

        const allowedAvailableValue = (currentData, allowedValues) => {
        if (!allowedValues || allowedValues.length === 0) {
            return { label: "", value: "", alt: "" };
        }
        const usedValues = currentData.map(item => item.value);
        const availableOption = allowedValues.find(option => 
            !usedValues.includes(option.value)
        );
        return availableOption || { label: "", value: "", alt: "" };
    };

    const handleDropdownChange = (newData) => {
        if (onChange) {
            onChange(JSON.stringify(newData));
        }
    };

    const addDropdownRow = () => {
        const currentData = parseDropdownData(value);
        // const newRow = { label: "", value: "", alt: "" };
        const newRow = allowedAvailableValue(currentData, allowedValues);
        const updatedData = [...currentData, newRow];
        handleDropdownChange(updatedData);
    };

    const removeDropdownRow = (index) => {
        const currentData = parseDropdownData(value);
        const updatedData = currentData.filter((_, i) => i !== index);
        handleDropdownChange(updatedData);
    };

    const updateDropdownRow = (index, field, newValue) => {
        const currentData = parseDropdownData(value);
        const updatedData = [...currentData];
        updatedData[index] = { ...updatedData[index], [field]: newValue };
        handleDropdownChange(updatedData);
    };

    const dropdownData = parseDropdownData(value);

    const displayData = dropdownData.length > 0 ? dropdownData : [{ label: "", value: "", alt: "" }];

     const isAvailableOptions = () => {
        if (!allowedValues || allowedValues.length === 0) return true; 
        const usedValues = dropdownData.map(item => item.value);
        return allowedValues.some(option => !usedValues.includes(option.value));
    };
    return (
        <div className={styles.dropdownWithLabelValueAlt}>
            <div className={styles.dropdownHeader}>
                <span className={styles.dropdownTitle}>
                    {title}
                </span>
                <button
                    type="button"
                    className={styles.addRowButton}
                    onClick={addDropdownRow}
                    disabled={disabled || !isAvailableOptions()}
                    title={!isAvailableOptions() ? "All available options have been added" : "Add new row"}
                >
                    +
                </button>
            </div>

            <div className={styles.dropdownTable}>
                <div className={styles.dropdownTableHeader}>
                    <span>Label</span>
                    <span>Value</span>
                    <span>Alt</span>
                    <span>Action</span>
                </div>

                {displayData.map((row, index) => (
                    <div key={index} className={styles.dropdownTableRow}>
                        <div className={styles.inputWrapper}>
                            <label className={styles.mobileLabel}>Label:</label>
                            <InputBox
                                value={row.label || ""}
                                onChange={(e) => updateDropdownRow(index, 'label', e.target.value)}
                                placeholder={placeholder.label}
                                disabled={disabled || inputsDisabled} 
                            />
                        </div>

                        <div className={styles.inputWrapper}>
                            <label className={styles.mobileLabel}>Value:</label>
                            <InputBox
                                value={row.value || ""}
                                onChange={(e) => updateDropdownRow(index, 'value', e.target.value)}
                                placeholder={placeholder.value}
                                disabled={disabled || inputsDisabled} 
                            />
                        </div>

                        <div className={styles.inputWrapper}>
                            <label className={styles.mobileLabel}>Alt:</label>
                            <InputBox
                                value={row.alt || ""}
                                onChange={(e) => updateDropdownRow(index, 'alt', e.target.value)}
                                placeholder={placeholder.alt}
                                disabled={disabled || inputsDisabled} 
                            />
                        </div>

                        <div className={styles.actionWrapper}>
                            <button
                                type="button"
                                className={styles.removeRowButton}
                                onClick={() => removeDropdownRow(index)}
                                disabled={disabled || displayData.length <= 1}
                                title="Remove this row"
                            >
                                −
                            </button>
                        </div>
                    </div>
                ))}
            </div>

            {displayData.length === 0 && (
                <div className={styles.emptyState}>
                    <p>No items added yet. Click the + button to add your first item.</p>
                </div>
            )}
        </div>
    );
};

export default DropdownWithLabelValueAlt;